export var Comparison;
(function (Comparison) {
    Comparison[Comparison["Less"] = -1] = "Less";
    Comparison[Comparison["Greater"] = 1] = "Greater";
    Comparison[Comparison["Equal"] = 0] = "Equal";
})(Comparison || (Comparison = {}));
export function compare(a, b) {
    if (a === b) {
        return 0;
    }
    if (a == null) {
        return -1;
    }
    if (b == null) {
        return 1;
    }
    return a < b
        ? -1
        : a > b
            ? 1
            : 0;
}
